
import { defineComponent } from "vue";

export interface ImageSize {
  sm: {
    width: number;
    height: number;
  };
  md: {
    width: number;
    height: number;
  };
  lg: {
    width: number;
    height: number;
  };
}

export default defineComponent({
  name: "Imgix",
  props: {
    imageUrl: {
      type: String,
      required: true,
      default: "",
    },
    imageSize: {
      type: Object as () => ImageSize,
      required: false,
      default: undefined,
    },
  },
});
